import { HttpService } from '@/shared/services'
import ApprovalFlow from '../models/ApprovalFlow'
import List from '@/shared/dtos/List'
import CreateApprovalFlowInputDto from './interfaces/CreateApprovalFlowInputDto'
import UpdateApprovalFlowInputDto from './interfaces/UpdateApprovalFlowInputDto'

const http = new HttpService()

export const getApprovalFlowsByPayrollConfigId = async (
  payrollConfigId: string,
  search?: string
) => {
  let url = `/approvalflows/payrollConfig/${payrollConfigId}`
  if (search !== undefined && search !== null) {
    url += `?search=${search}`
  }

  const response = await http.get<List<ApprovalFlow[]>>(url)
  return response.data
}

export const deleteApprovalFlowId = async (approvalFlowId: string) => {
  const response = await http.delete(`/approvalflows/${approvalFlowId}`)
  return response.data
}

export const createApprovalFlow = async (
  approvalFlow: CreateApprovalFlowInputDto
) => {
  const response = await http.post<CreateApprovalFlowInputDto, string>(
    `/approvalflows`,
    approvalFlow
  )

  return response.data
}

export const getApprovalFlowById = async (approvalFlowId: string) => {
  const response = await http.get<ApprovalFlow>(
    `/approvalflows/${approvalFlowId}`
  )
  return response.data
}

export const updateApprovalFlow = async (
  approvalFlowId: string,
  approvalFlow: UpdateApprovalFlowInputDto
) => {
  const response = await http.put<UpdateApprovalFlowInputDto, string>(
    `/approvalFlows/${approvalFlowId}`,
    approvalFlow
  )

  return response.data
}
